export const TICKETING_BOT_AUTHOR = "coPetence Ticketing";
export const TICKETING_DELIMITER = ":::";

export type PresentedComment = {
  displayAuthor: string;
  displayBody: string;
};

function isDelimiterLine(line: string): boolean {
  return line.trim() === TICKETING_DELIMITER;
}

function firstNonBlankLine(lines: string[]): string | null {
  for (const line of lines) {
    const trimmed = line.trim();
    if (trimmed) return trimmed;
  }
  return null;
}

export function presentComment(
  authorName: string | undefined,
  body: string,
): PresentedComment {
  const safeAuthor = authorName?.trim() || "Unknown";

  const lines = body.split(/\r?\n/);
  const delimiterIndex = lines.findIndex(isDelimiterLine);

  if (delimiterIndex === -1) {
    return { displayAuthor: safeAuthor, displayBody: body };
  }

  const headerLines = lines.slice(0, delimiterIndex);
  const nextLines = lines.slice(delimiterIndex + 1);

  const parsedAuthor = firstNonBlankLine(headerLines);
  const displayBody = nextLines.join("\n").replace(/^\s+/, "");

  const shouldUseParsedHeader =
    safeAuthor === TICKETING_BOT_AUTHOR || safeAuthor === parsedAuthor;

  if (!shouldUseParsedHeader) {
    return { displayAuthor: safeAuthor, displayBody: body };
  }

  return {
    displayAuthor: parsedAuthor || safeAuthor,
    displayBody,
  };
}
